import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
export default class PartnershipWall {
    constructor() {
        this.section = document.querySelector('.block-partnership-wall');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');

        this.ready();
    }

    ready() {
        new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 1,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 1,
                    centeredSlides: true,
                    navigation: {
                        nextEl: this.navigationNextMobile,
                        prevEl: this.navigationPrevMobile,
                    },
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    navigation: {
                        nextEl: this.navigationNext,
                        prevEl: this.navigationPrev,
                    },
                },
            },
        });
    }
}

if (document.querySelector('.block-partnership-wall')) {
    new PartnershipWall();
}
